import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the UtilsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UtilsProvider {

    constructor(public http: HttpClient) {
        console.log('Hello UtilsProvider Provider');
    }

    dd2dms(coordlat, coordlon) {
        let retVal = new Array();

        let ddLat = coordlat.toString();
        ddLat.replace(",", ".");

        let ddLong = coordlon.toString();
        ddLong.replace(",", ".");

        if (ddLat.indexOf('.') == -1) ddLat += ".0";
        if (ddLat.indexOf('.') == ddLat.length - 1) ddLat += "0";
        if (ddLong.indexOf('.') == -1) ddLong += ".0";
        if (ddLong.indexOf('.') == ddLong.length - 1) ddLong += "0";

        let ddLatVal = ddLat;
        let ddLongVal = ddLong;

        // degrees = degrees
        let ddLatVals = ddLatVal.split(".");
        let dmsLatDeg = ddLatVals[0];

        let ddLongVals = ddLongVal.split(".");
        let dmsLongDeg = ddLongVals[0];

        // * 60 = mins
        // let ddLatRemainder  = ("0." + ddLatVals[1]) * 60;
        let ddLatRemainder = +("0." + ddLatVals[1]) * 60;

        let dmsLatMinVals = ddLatRemainder.toString().split(".");
        // let dmsLatMin = dmsLatMinVals[0];
        let dmsLatMin = +dmsLatMinVals[0];
        if (dmsLatMinVals.length == 1) dmsLatMinVals[1] = "0";

        // let ddLongRemainder = ("0." + ddLongVals[1]) * 60;
        let ddLongRemainder = +("0." + ddLongVals[1]) * 60;

        let dmsLongMinVals = ddLongRemainder.toString().split(".");
        // let dmsLongMin = dmsLongMinVals[0];
        let dmsLongMin = +dmsLongMinVals[0];
        // if (dmsLongMinVals.length == 1) dmsLongMinVals[1]=0;
        if (dmsLongMinVals.length == 1) dmsLongMinVals[1] = "0";

        // * 60 again = secs
        // let ddLatMinRemainder = ("0." + dmsLatMinVals[1]) * 60;
        let ddLatMinRemainder = +("0." + dmsLatMinVals[1]) * 60;
        let dmsLatSec = Math.round(ddLatMinRemainder);
        let secLatDiv = dmsLatSec / 60;
        dmsLatSec = dmsLatSec % 60;
        secLatDiv = Math.floor(secLatDiv);
        if (secLatDiv) {
            dmsLatMin++;
            let minLatDiv = dmsLatMin / 60;
            minLatDiv = Math.floor(minLatDiv);
            dmsLatMin = dmsLatMin % 60;
            if (minLatDiv) dmsLatDeg++;
        }

        // let ddLongMinRemainder = ("0." + dmsLongMinVals[1]) * 60;
        let ddLongMinRemainder = +("0." + dmsLongMinVals[1]) * 60;
        let dmsLongSec = Math.round(ddLongMinRemainder);
        let secLongDiv = dmsLongSec / 60;
        dmsLongSec = dmsLongSec % 60;
        secLongDiv = Math.floor(secLongDiv);
        if (secLongDiv) {
            dmsLongMin++;
            let minLongDiv = dmsLongMin / 60;
            minLongDiv = Math.floor(minLongDiv);
            dmsLongMin = dmsLongMin % 60;
            if (minLongDiv) dmsLongDeg++;
        }

        retVal[0] = dmsLatDeg; 		// Lat degrees
        retVal[1] = dmsLatMin;  	// Lat mins
        retVal[2] = dmsLatSec;  	// Lat secs
        retVal[3] = dmsLongDeg;		// Lon degrees
        retVal[4] = dmsLongMin;  	// Lon mins
        retVal[5] = dmsLongSec;  	// Lon secs

        return (retVal);
    }

    dd2dmm(coordlat, coordlon) {
        let retVal = new Array();

        let ddLat = coordlat.toString();
        ddLat.replace(",", ".");

        let ddLong = coordlon.toString();
        ddLong.replace(",", ".");

        if (ddLat.indexOf('.') == -1) ddLat += ".0";
        if (ddLat.indexOf('.') == ddLat.length - 1) ddLat += "0";
        if (ddLong.indexOf('.') == -1) ddLong += ".0";
        if (ddLong.indexOf('.') == ddLong.length - 1) ddLong += "0";

        // degrees = degrees
        let ddLatVals = ddLat.split(".");
        let dmsLatDeg = ddLatVals[0];

        let ddLongVals = ddLong.split(".");
        let dmsLongDeg = ddLongVals[0];

        // * 60 = mins
        let dmsLatMin = +("0." + ddLatVals[1]) * 60;
        let dmsLongMin = +("0." + ddLongVals[1]) * 60;

        retVal[0] = dmsLatDeg; 		// Lat degrees
        retVal[1] = dmsLatMin.toFixed(5);  	// Lat mins
        //retVal[2] = dmsLatSec;  	// Lat secs

        retVal[3] = dmsLongDeg;		// Lon degrees
        retVal[4] = dmsLongMin.toFixed(5);  	// Lon mins
        //retVal[5] = dmsLongSec;  	// Lon secs

        return (retVal);
    }


    dms2dd(dmsLatDeg, dmsLatMin, dmsLatSec, dmsLongDeg, dmsLongMin, dmsLongSec) {
        let retVal = new Array();
        // find decimal latitude
        let ddLatVal = dmsLatDeg * 1 + dmsLatMin / 60 + dmsLatSec / 3600;
        //ddLatVal = dmsLatHem.options[dmsLatHem.selectedIndex].value + ddLatVal;

        // find decimal longitude
        let ddLongVal = dmsLongDeg * 1 + dmsLongMin / 60 + dmsLongSec / 3600;
        //ddLongVal = dmsLongHem.options[dmsLongHem.selectedIndex].value + ddLongVal;

        // write values
        retVal[0] = ddLatVal;
        retVal[1] = ddLongVal;

        return (retVal);
    }

    dmm2dd(dmmLatDeg, dmmLatMin, dmmLongDeg, dmmLongMin) {
        let retVal = new Array();
        // find decimal latitude
        let ddLatVal = dmmLatDeg * 1 + dmmLatMin / 60;
        //ddLatVal = dmsLatHem.options[dmsLatHem.selectedIndex].value + ddLatVal;

        // find decimal longitude
        let ddLongVal = dmmLongDeg * 1 + dmmLongMin / 60;
        //ddLongVal = dmsLongHem.options[dmsLongHem.selectedIndex].value + ddLongVal;

        // write values
        retVal[0] = ddLatVal;
        retVal[1] = ddLongVal;

        return (retVal);
    }

    dmm2dms(dmmLatDeg, dmmLatMin, dmmLongDeg, dmmLongMin) {
        let retVal = new Array();

        // degrees = degrees
        let dmsLatDeg = dmmLatDeg;
        let dmsLongDeg = dmmLongDeg;

        let ddLat = dmmLatMin.toString();
        ddLat.replace(",", ".");

        let ddLong = dmmLongMin.toString();
        ddLong.replace(",", ".");

        if (ddLat.indexOf('.') == -1) ddLat += ".0";
        if (ddLat.indexOf('.') == ddLat.length - 1) ddLat += "0";
        if (ddLong.indexOf('.') == -1) ddLong += ".0";
        if (ddLong.indexOf('.') == ddLong.length - 1) ddLong += "0";

        let ddLatVal = ddLat;
        let ddLongVal = ddLong;

        let ddLatVals = ddLatVal.split(".");
        let dmsLatMin = ddLatVals[0];

        let ddLongVals = ddLongVal.split(".");
        let dmsLongMin = ddLongVals[0];

        // * 60 = mins
        let ddLatRemainder = +("0." + ddLatVals[1]) * 60;
        let dmsLatSec = Math.round(ddLatRemainder);
        let secLatDiv = dmsLatSec / 60;
        dmsLatSec = dmsLatSec % 60;
        secLatDiv = Math.floor(secLatDiv);
        if (secLatDiv) {
            dmsLatMin++;
            let minLatDiv = dmsLatMin / 60;
            minLatDiv = Math.floor(minLatDiv);
            dmsLatMin = dmsLatMin % 60;
            if (minLatDiv) dmsLatDeg++;
        }

        let ddLongRemainder = +("0." + ddLongVals[1]) * 60;
        let dmsLongSec = Math.round(ddLongRemainder);
        let secLongDiv = dmsLongSec / 60;
        dmsLongSec = dmsLongSec % 60;
        secLongDiv = Math.floor(secLongDiv);
        if (secLongDiv) {
            dmsLongMin++;
            let minLongDiv = dmsLongMin / 60;
            minLongDiv = Math.floor(minLongDiv);
            dmsLongMin = dmsLongMin % 60;
            if (minLongDiv) dmsLongDeg++;
        }

        retVal[0] = dmsLatDeg; 		// Lat degrees
        retVal[1] = dmsLatMin;  	// Lat mins
        retVal[2] = dmsLatSec;  	// Lat secs
        retVal[3] = dmsLongDeg;		// Lon degrees
        retVal[4] = dmsLongMin;  	// Lon mins
        retVal[5] = dmsLongSec;  	// Lon secs

        return (retVal);
    }

    dms2dmm(dmsLatDeg, dmsLatMin, dmsLatSec, dmsLongDeg, dmsLongMin, dmsLongSec) {
        let retVal = new Array();

        // degrees = degrees
        let dmmLatDeg = dmsLatDeg;
        let dmmLongDeg = dmsLongDeg;

        let dmmLatMin = dmsLatMin * 1 + dmsLatSec / 60;
        let dmmLongMin = dmsLongMin * 1 + dmsLongSec / 60;

        // write values
        retVal[0] = dmmLatDeg; 		// Lat degrees
        retVal[1] = dmmLatMin.toFixed(5);  	// Lat mins

        retVal[3] = dmmLongDeg;		// Lon degrees
        retVal[4] = dmmLongMin.toFixed(5);  	// Lon mins

        return (retVal);
    }




}



// WEBPACK FOOTER //
// ./src/providers/utils/utils.ts